/*
 *  @2019 CS-Core project.
 *
 */

import React, { Component } from "react";import { Layout, Typography } from "antd";
import styled from "styled-components";import { Link } from "react-router-dom";

import AuthenticatedNavigation from "../components/Navigation";
import ProfileMenu from "../components/ProfileMenu";
import ErrorBoundary from "../components/ErrorBoundary";
import SomethingWentWrong from "../components/SomethingWentWrong";
import Button from "../components/Buttons";
import { LoaderComponent } from "../lightState/Loader";
import SmallMenu from '../components/smallMenu'

import { ErrorHandlingLS } from "../lightState/ErrorHandling";
import typo, { MESSAGE } from "../constants/dictionaries";

// Redux
import { connect } from "react-redux";

// Styles
import styles from "./LayoutAuthenticated.module.scss";
import {FUNCTION_ACTIONS} from "../redux/actions";

const { Sider, Content } = Layout;

const SomethingWentWrongNotify = styled.div`
  background-color: #f44336;
  padding: 5px 10px;
  color: #fff;
  text-align: center;
`;

const Fixed = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 99999;
`;

const SiderWrapper = styled(Sider)`
  background-color: #f3f2f1 !important;
`;

class LayoutAuthenticated extends Component {
  state = {
    isCollapsed: localStorage.getItem("GEN_menu_isCollapsed") === "true",
    minimizeMenu: localStorage.getItem("GEN_menu_isCollapsed") === "true"
  };

  onCollapse = collapse => {
    this.setState({ minimizeMenu: !this.state.minimizeMenu });
    this.setState({ isCollapsed: collapse });
    localStorage.setItem("GEN_menu_isCollapsed", collapse ? "true" : "false");
    if (collapse) {
      localStorage.setItem("GEN_defaultOpenKeys", "[]");
    }
  };

  // eslint-disable-next-line
  componentWillReceiveProps() {
    if (ErrorHandlingLS.getState().error) {
      ErrorHandlingLS.setState({ error: false });
    }
  }

  render() {
    const { children, user } = this.props;
    var unitName = (process.env.REACT_APP_CAP_TRIEN_KHAI === "2" || process.env.REACT_APP_CAP_TRIEN_KHAI === "3") ? (" " + process.env.REACT_APP_TEN_DVHC) : "";

    return  (user && user.profile) ? (
      <Layout theme="light" key="neverchange" className={styles.layout}>
        <div className='layout-box-head'>
          <div className='layout-box-logout'><ProfileMenu/></div>
          <div className='layout-box-menu' style={{float: 'left'}} ><SmallMenu/></div>
          <div className='box-layout-name-app'>{typo.cscore_nameApp}{unitName}</div>
        </div>
        <Layout>
        
          <SiderWrapper
            className='box-sidebar'
            breakpoint="lg"
            collapsedWidth="80"
            collapsible
            collapsed={this.state.isCollapsed}
            onCollapse={this.onCollapse}
            width={270}
          >
            <AuthenticatedNavigation collapsed={this.state.minimizeMenu}  isCollapsed={this.state.isCollapsed} {...this.props}/>
          </SiderWrapper>
          <Layout className={styles.layoutHasSlider} >
            {/* <Content style={{overflow: "hidden"}}>
              <ErrorBoundary>
                <SomethingWentWrongLS>
                  <LoaderComponent />
                  {user ? children : <h3 style={{marginLeft: 20}}>{typo.cscore_unauthorized}</h3>}
                </SomethingWentWrongLS>
              </ErrorBoundary>
            </Content> */}
            <Content className={styles.contentWrapper}>
  <div className={styles.contentInner}>
    <LoaderComponent />
    {user ? children : <h3>{typo.cscore_unauthorized}</h3>}
  </div>
</Content>
          </Layout>
        </Layout>
      </Layout>
    ) : ''
  }
}

const SomethingWentWrongLS = ErrorHandlingLS.withLight()(
  ({ error, children }) => (
    <>
      <SomethingWentWrong {...error} className="mb-20" />
      {error.error === false && children}
    </>
  )
);

const Handle409 = ErrorHandlingLS.withLight()(({ error }) => {
  // console.log("++++++++", error);
  return error.error409 ? (
    <Fixed>
      <SomethingWentWrongNotify>
        {MESSAGE.CSCORE_THERE_IS_SOMETHING_WRONG}{" "}
        <Link to={window.location.pathname}>
          <Button
            type="grayOutline"
            onClick={() => {
              ErrorHandlingLS.setState({ error409: false });
            }}
          >
            Reload
          </Button>
        </Link>
      </SomethingWentWrongNotify>
    </Fixed>
  ) : false;
});

const mapStateToProps = state => ({
  user: state.oidc.user,
  functions: state.functions
});

const mapDispatchToProps = (dispatch) => ({
  addFunctions: (payload) => dispatch(FUNCTION_ACTIONS.addListFunctions(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutAuthenticated);